// import { useEffect, useState } from "react";
// import axios from "axios";


// import {
//     FaEdit,
//     FaPlus,
//     FaTimes,
//     FaClipboardList,
//     FaChevronDown,
//     FaChevronUp
//   } from "react-icons/fa";

// export default function CarManagement() {
//     const [cars, setCars] = useState([]);
//     const [manufacturers, setManufacturers] = useState([]);
//     const [newCar, setNewCar] = useState({
//         name: "",
//         manufacturerId: "",
//         type: "",
//         capacity: "",
//         perDay: "",
//         isPopular: false,
//         isRecommended: false,
//         travelType: "",
//         vehicleType: "",
//         isBooked: false,
//         image: null
//     });
//     const [showForm, setShowForm] = useState(false);

//     useEffect(() => {
//         fetchCars();
//         fetchManufacturers();
//     }, []);

//     const fetchCars = async () => {
//         try {
//             const response = await axios.get("https://localhost:7009/api/CarDetail");
//             setCars(response.data);
//         } catch (error) {
//             console.error("Error fetching cars:", error);
//         }
//     };

//     const fetchManufacturers = async () => {
//         try {
//             const response = await axios.get("https://localhost:7009/api/Manufacturer");
//             setManufacturers(response.data);
//         } catch (error) {
//             console.error("Error fetching manufacturers:", error);
//         }
//     };

//     const handleChange = (e) => {
//         const { name, type, value, checked, files } = e.target;
//         if (type === "file") {
//             setNewCar(prevState => ({ ...prevState, image: files[0] }));
//         } else {
//             setNewCar(prevState => ({ ...prevState, [name]: type === "checkbox" ? checked : value }));
//         }
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (!newCar.image) {
//             alert("Please select an image.");
//             return;
//         }

//         const formData = new FormData();
//         formData.append("name", newCar.name);
//         formData.append("manufacturerId", newCar.manufacturerId);
//         formData.append("type", newCar.type);
//         formData.append("capacity", newCar.capacity);
//         formData.append("perDay", newCar.perDay);
//         formData.append("isPopular", newCar.isPopular);
//         formData.append("isRecommended", newCar.isRecommended);
//         formData.append("travelType", newCar.travelType);
//         formData.append("vehicleType", newCar.vehicleType);
//         formData.append("isBooked", newCar.isBooked);
//         formData.append("imageFile", newCar.image);

//         try {
//             await axios.post("https://localhost:7009/api/CarDetail", formData, {
//                 headers: { "Content-Type": "multipart/form-data" }
//             });
//             setNewCar({
//                 name: "",
//                 manufacturerId: "",
//                 type: "",
//                 capacity: "",
//                 perDay: "",
//                 isPopular: false,
//                 isRecommended: false,
//                 travelType: "",
//                 vehicleType: "",
//                 isBooked: false,
//                 image: null
//             });
//             fetchCars();
//             setShowForm(false); // Close the popup after submission
//         } catch (error) {
//             console.error("Error adding car:", error.response?.data || error.message);
//         }
//     };

//     return (
//         <div className="flex h-screen">



          
//             {/* Main Content */}
//             <div className="flex-1 p-6 overflow-auto">
//             {/* <img src={flag} alt="Logo" className="h-10 w-auto mr-2" /> */}
//                 <h2 className="text-2xl font-bold mb-4"></h2>

             
//                 {/* Popup for Car Form */}
//                 {showForm && (
//     <div 
//         className="fixed inset-0  bg-opacity-50 flex justify-center items-center z-50  overflow-y-auto py-10 min-h-screen bg-gray-600 bg-opacity-75"
//         onClick={() => setShowForm(false)}
//     >
//         <div className="flex items-center justify-center">
//         <div
//           className={`bg-white 
//             ? "opacity-80"
//             : "bg-opacity-100"} p-8 m-5 rounded-3xl shadow-lg max-w-xl w-full relative`}
//         >
//           <div className="flex justify-end ">
//             <button
             
//               className="flex relative items-center justify-end cursor-pointer text-xl text-gray-600 hover:text-gray-800"
//               aria-label="Close"
//             >
//               <FaTimes />
//             </button>
//           </div>
          
//         <div 
            
//             onClick={(e) => e.stopPropagation()} 
//         >
            
//                             <h3 className="text-xl font-bold mb-4">Add New Car</h3>
//                         <form onSubmit={handleSubmit}>
//                         <input 
//                     type="text" 
//                     name="name" 
//                     value={newCar.name} 
//                     onChange={handleChange} 
//                     placeholder="Car Name" 
//                     className="border p-2 rounded w-full mb-2" 
//                     required 
//                 />
//                 <select 
//                     name="manufacturerId" 
//                     value={newCar.manufacturerId} 
//                     onChange={handleChange} 
//                     className="border p-2 rounded w-full mb-2" 
//                     required
//                 >
//                     <option value="">Select Manufacturer</option>
//                     {manufacturers.map(manufacturer => (
//                         <option key={manufacturer.manufacturerId} value={manufacturer.manufacturerId}>
//                             {manufacturer.name}
//                         </option>
//                     ))}
//                 </select>
//                 <input 
//                     type="text" 
//                     name="type" 
//                     value={newCar.type} 
//                     onChange={handleChange} 
//                     placeholder="Type" 
//                     className="border p-2 rounded w-full mb-2" 
//                     required 
//                 />
//                 <input 
//                     type="text" 
//                     name="capacity" 
//                     value={newCar.capacity} 
//                     onChange={handleChange} 
//                     placeholder="Capacity" 
//                     className="border p-2 rounded w-full mb-2" 
//                     required 
//                 />
//                 <input 
//                     type="text" 
//                     name="perDay" 
//                     value={newCar.perDay} 
//                     onChange={handleChange} 
//                     placeholder="Per Day" 
//                     className="border p-2 rounded w-full mb-2" 
//                     required 
//                 />
//                 <div className="flex items-center mb-2">
//                     <input 
//                         type="checkbox" 
//                         name="isPopular" 
//                         checked={newCar.isPopular} 
//                         onChange={handleChange} 
//                         className="mr-2" 
//                     />
//                     <label>Popular</label>
//                 </div>
//                 <div className="flex items-center mb-2">
//                     <input 
//                         type="checkbox" 
//                         name="isRecommended" 
//                         checked={newCar.isRecommended} 
//                         onChange={handleChange} 
//                         className="mr-2" 
//                     />
//                     <label>Recommended</label>
//                 </div>
//                 <input 
//                     type="text" 
//                     name="travelType" 
//                     value={newCar.travelType} 
//                     onChange={handleChange} 
//                     placeholder="Travel Type" 
//                     className="border p-2 rounded w-full mb-2" 
//                     required 
//                 />
//                 <input 
//                     type="text" 
//                     name="vehicleType" 
//                     value={newCar.vehicleType} 
//                     onChange={handleChange} 
//                     placeholder="Vehicle Type" 
//                     className="border p-2 rounded w-full mb-2" 
//                     required 
//                 />
//                 <div className="flex items-center mb-2">
//                     <input 
//                         type="checkbox" 
//                         name="isBooked" 
//                         checked={newCar.isBooked} 
//                         onChange={handleChange} 
//                         className="mr-2" 
//                     />
//                     <label>Booked</label>
//                 </div>
//                 <input 
//                     type="file" 
//                     name="imageFile" 
//                     accept="image/*" 
//                     onChange={handleChange} 
//                     className="border p-2 rounded w-full mb-2" 
//                     required 
//                 />
//                 <button 
//                     type="submit" 
//                     className="bg-blue-500 text-white p-2 rounded w-full"
//                 >
//                     Add Car
//                 </button>
//             </form>
//             </div>
//                         </div>
//                     </div>
//                     </div>
                   
//                 )}

//                 {/* Car List Table */}
//                 <div className="mt-6 relative">
   

//     <div
//         className="relative bg-white lg:w-[90%] w-[100%] lg:mx-3 lg:px-10 lg:py-10 p-5 lg:rounded-tl-[3rem] rounded-lg shadow-xl"
//         style={{
//             backdropFilter: "blur(15px)",
//             boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
//             border: "1px solid rgba(182, 168, 168, 0.3)",
//         }}
//     >


// <div >
//     {/* Plus Icon Button (Top Right) */}
//     <button
//         title="Add New"
//         onClick={() => setShowForm(true)}
//         className="absolute top-3 right-3 bg-blue-500 hover:bg-green-600 rounded-full p-3 text-white text-lg lg:text-2xl"
//     >
//         <FaPlus />
//     </button>

//     <div className="overflow-x-auto">
//     <h3 className="text-xl font-bold mb-2">Car List</h3>

//     <table className="w-full text-sm text-left text-gray-500">
//         <thead className="text-xs text-gray-700 uppercase bg-gray-200">
//             <tr className="bg-gray-100">
//                 <th className="px-4 py-3">Car ID</th>
//                 <th className="px-4 py-3">Car Name</th>
//                 <th className="px-4 py-3">Manufacturer ID</th>
//                 <th className="px-4 py-3">Manufacturer</th>
//                 <th className="px-4 py-3">Type</th>
//                 <th className="px-4 py-3">Capacity</th>
//                 <th className="px-4 py-3">Per Day</th>
//                 <th className="px-4 py-3">Popular</th>
//                 <th className="px-4 py-3">Recommended</th>
//                 <th className="px-4 py-3">Image</th>
//             </tr>
//         </thead>
//         <tbody>
//             {cars.map((car) => (
//                 <tr key={car.id} className="border">
//                     <td className="px-4 py-2 font-medium text-gray-900">{car.id}</td>
//                     <td className="px-4 py-2 ">{car.name}</td>
//                     <td className="px-4 py-2 ">{car.manufacturerId}</td>
//                     <td className="px-4 py-2">{manufacturers.find((m) => m.manufacturerId === car.manufacturerId)?.name || "Unknown"}</td>
//                     <td className="px-4 py-2">{car.type}</td>
//                     <td className="px-4 py-2">{car.capacity}</td>
//                     <td className="px-4 py-2">{car.perDay}</td>
//                     <td className="px-4 py-2">{car.isPopular ? "✔" : "✖"}</td>
//                     <td className="px-4 py-2">{car.isRecommended ? "✔" : "✖"}</td>
//                     <td className="px-4 py-2">
//                         {car.imageUrl && <img src={car.imageUrl} alt="Car" className="h-12 w-20 object-cover rounded-md" />}
//                     </td>
//                 </tr>
//             ))}
//         </tbody>
//     </table>
// </div>

//                 </div>
//             </div>
//             </div>
//         </div>
//         </div>
//     );
// }


// import { useState } from "react";
// import axios from "axios";

// export default function PendingInvoices() {
//     const [invoices, setInvoices] = useState([]);
//     const [clientName, setClientName] = useState("");
//     const [mobileNumber, setMobileNumber] = useState("");
//     const [error, setError] = useState(null);
//     const [loading, setLoading] = useState(false);
//     const [invoiceItems, setInvoiceItems] = useState([]); // Initialize as empty array
//     const [isAdvancePayment, setIsAdvancePayment] = useState(false);
    
//     const [tax, setTax] = useState(0);
//     const [discount, setDiscount] = useState(0);
//     const [paidAmount, setPaidAmount] = useState(0);
//     const [advanceAmount, setAdvanceAmount] = useState(0);
   


//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true);
        
//         const invoiceData = {
//             ClientName: clientName,
//             MobileNumber: mobileNumber,
//             Tax: tax,
//             Discount: discount,
//             PaidAmount: paidAmount,
//             AdvanceAmount: isAdvancePayment ? advanceAmount : 0,
//             Items: invoiceItems,
//         };
        
//         try {
//             const response = await axios.post("https://invoice.dockyardsoftware.com/api/Invoice", invoiceData);
//             console.log("Invoice submitted successfully", response.data);
//             alert("Invoice submitted successfully");
//         } catch (error) {
//             console.error("Error submitting invoice", error.response);
//             alert("Failed to submit invoice");
//         }
        
//         setLoading(false);
//     };

//     const fetchPendingInvoices = async () => {
//         setLoading(true);
//         try {
//             const response = await axios.get("https://invoice.dockyardsoftware.com/api/Invoice/PendingByCustomer", {
//                 params: { clientName, mobileNumber }
//             });

//             console.log("Fetched Data:", response.data);

//             // Extracting the array of invoices from the response
//             const invoicesData = response.data?.$values || [];

//             // Set the invoices
//             setInvoices(invoicesData);
//             setError(null);
//         } catch (error) {
//             console.error("Error fetching invoices:", error.response);
//             setError(error.response?.data?.message || "Error fetching pending invoices");
//             setInvoices([]);
//         }
//         setLoading(false);
//     };

//     // Fetch related invoice items when a "Pending" button is clicked
//     const fetchInvoiceItems = async (invoiceNumber) => {
//         try {
//             const response = await axios.get(`https://invoice.dockyardsoftware.com/api/Invoice/${invoiceNumber}`);
            
//             // Ensure items are fetched from the response, assuming it's under 'items.$values'
//             const items = response.data?.items?.$values || []; // Ensure this matches your response structure
//             console.log("Invoice Items Fetched:", items);

//             setInvoiceItems(items); // Update the state with invoice items
//         } catch (error) {
//             console.error("Error fetching invoice items:", error);
//         }
//     };

//     return (
//         <div className="flex flex-col items-center p-6">
//             <h2 className="text-2xl font-bold mb-4">Pending Invoices</h2>
//             <div className="mb-4 w-full max-w-md">
//                 <input
//                     type="text"
//                     placeholder="Client Name"
//                     value={clientName}
//                     onChange={(e) => setClientName(e.target.value)}
//                     className="border p-2 rounded w-full mb-2"
//                 />
//                 <input
//                     type="text"
//                     placeholder="Mobile Number"
//                     value={mobileNumber}
//                     onChange={(e) => setMobileNumber(e.target.value)}
//                     className="border p-2 rounded w-full mb-2"
//                 />
//                 <button
//                     onClick={fetchPendingInvoices}
//                     className="bg-blue-500 text-white p-2 rounded w-full"
//                 >
//                     {loading ? "Searching..." : "Search"}
//                 </button>
//             </div>
//             {error && <p className="text-red-500">{error}</p>}
//             <div className="overflow-x-auto w-full max-w-4xl">
//                 <table className="w-full text-sm text-left text-gray-500 border">
//                     <thead className="text-xs text-gray-700 uppercase bg-gray-200">
//                         <tr>
//                             <th className="px-4 py-3">Invoice Number</th>
//                             <th className="px-4 py-3">Base Invoice Number</th>
//                             <th className="px-4 py-3">Client Name</th>
//                             <th className="px-4 py-3">Total</th>
//                             <th className="px-4 py-3">Date</th>
//                             <th className="px-4 py-3">Paid</th>
//                             <th className="px-4 py-3">Advance</th>
//                             <th className="px-4 py-3">Remaining Balance</th>
//                             <th className="px-4 py-3">Pending</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {loading ? (
//                             <tr>
//                                 <td colSpan="9" className="text-center py-3 text-gray-500">
//                                     Loading invoices...
//                                 </td>
//                             </tr>
//                         ) : invoices.length > 0 ? (
//                             invoices.map((invoice) => (
//                                 <tr key={invoice.invoiceNumber} className="border">
//                                     <td className="px-4 py-2">{invoice.invoiceNumber}</td>
//                                     <td className="px-4 py-2">{invoice.baseInvoiceNumber}</td>
//                                     <td className="px-4 py-2">{invoice.clientName}</td>
//                                     <td className="px-4 py-2">{invoice.total}</td>
//                                     <td className="px-4 py-2">{invoice.date}</td>
//                                     <td className="px-4 py-2">{invoice.paidAmount}</td>
//                                     <td className="px-4 py-2">{invoice.advanceAmount}</td>
//                                     <td className="px-4 py-2">{invoice.remainingBalance}</td>
//                                     <td className="px-4 py-2">
//                                         {invoice.pendingStatus === "Pending" ? (
//                                             <a
//                                                 href="#"
//                                                 className="text-blue-500"
//                                                 onClick={() => fetchInvoiceItems(invoice.invoiceNumber)} // Fetch items for clicked invoice
//                                             >
//                                                 Pending
//                                             </a>
//                                         ) : (
//                                             "Completed"
//                                         )}
//                                     </td>
//                                 </tr>
//                             ))
//                         ) : (
//                             <tr>
//                                 <td colSpan="9" className="text-center py-3 text-gray-500">
//                                     No invoices found
//                                 </td>
//                             </tr>
//                         )}
//                     </tbody>
//                 </table>
//             </div>

//             {/* Invoice items table, always visible */}
//             <div className="overflow-x-auto w-full max-w-4xl mt-6">
//                 <h3 className="text-xl font-semibold mb-4">Invoice Items</h3>
//                 <table className="w-full text-sm text-left text-gray-500 border">
//                     <thead className="text-xs text-gray-700 uppercase bg-gray-200">
//                         <tr>
//                             <th className="px-4 py-3">Product Name</th>
//                             <th className="px-4 py-3">Quantity</th>
//                             <th className="px-4 py-3">Unit Price</th>
//                             <th className="px-4 py-3">Amount</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {invoiceItems.length > 0 ? (
//                             invoiceItems.map((item, index) => (
//                                 <tr key={index} className="border">
//                                     <td className="px-4 py-2">{item.productName}</td>
//                                     <td className="px-4 py-2">{item.quantity}</td>
//                                     <td className="px-4 py-2">{item.unitPrice}</td>
//                                     <td className="px-4 py-2">{item.unitPrice * item.quantity}</td>
//                                 </tr>
//                             ))
//                         ) : (
//                             <tr>
//                                 <td colSpan="4" className="text-center py-3 text-gray-500">
//                                     No invoice items found
//                                 </td>
//                             </tr>
//                         )}
//                     </tbody>
//                 </table>
//             </div>

//             {/* Invoice Summary Section */}
//             <div className="w-full max-w-4xl mt-6 p-4 border rounded bg-gray-50">
//             <div className="mb-4">
//                 <input
//                     type="checkbox"
//                     id="advancePayment"
//                     className="mr-2"
//                     checked={isAdvancePayment}
//                     onChange={(e) => setIsAdvancePayment(e.target.checked)}
//                 />
//                 <label htmlFor="advancePayment" className="text-gray-700">
//                     Is this an advance payment?
//                 </label>
//             </div>

//             {/* Show advance payment input when checkbox is checked */}
//             {isAdvancePayment && (
//                 <div className="mt-4">
//                     <label className="block text-gray-700">Advance Payment Amount:</label>
//                     <input type="number" className="border p-2 rounded w-full" placeholder="Enter advance payment amount" />
//                 </div>
//             )}

//             <div className="grid grid-cols-2 gap-4 mt-4">
//                 <div>
//                     <label className="block text-gray-700">Tax (%)</label>
//                     <input type="number" className="border p-2 rounded w-full" placeholder="0" />
//                 </div>
//                 <div>
//                     <label className="block text-gray-700">Discount (%)</label>
//                     <input type="number" className="border p-2 rounded w-full" placeholder="0" />
//                 </div>
//             </div>

//             <div className="mt-4">
//                 <label className="block text-gray-700">Paid Amount:</label>
//                 <input type="number" className="border p-2 rounded w-full" placeholder="0" />
//             </div>

//             <div className="flex justify-between items-center mt-6">
//                 <h3 className="text-lg font-bold">Total:</h3>
//                 <h3 className="text-lg font-bold text-gray-900">Rs. 0.00</h3>
//             </div>

//             <div className="mt-4 flex justify-center">
//                 <button className="bg-blue-500 text-white px-4 py-2 rounded">Submit Invoice</button>
//             </div>
//         </div>

        
//         </div>
//     );
// }

// import { useState } from "react";
// import axios from "axios";

// export default function PendingInvoices() {
//     const [invoices, setInvoices] = useState([]);
//     const [clientName, setClientName] = useState("");
//     const [mobileNumber, setMobileNumber] = useState("");
//     const [error, setError] = useState(null);
//     const [loading, setLoading] = useState(false);
//     const [invoiceItems, setInvoiceItems] = useState([]);
//     const [isAdvancePayment, setIsAdvancePayment] = useState(false);
//     const [tax, setTax] = useState(0);
//     const [discount, setDiscount] = useState(0);
//     const [paidAmount, setPaidAmount] = useState(0);
//     const [advanceAmount, setAdvanceAmount] = useState(0);
//     const [invoiceNumber, setInvoiceNumber] = useState("");
//     const [baseInvoiceNumber, setBaseInvoiceNumber] = useState("");
//     const [clientId, setClientId] = useState(0);

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true);

//         const invoiceData = {
//             invoiceNumber: invoiceNumber, // Added invoiceNumber
//             baseInvoiceNumber: baseInvoiceNumber, // Added baseInvoiceNumber
//             baseInvoiceNumberId: 0, // Add the logic for this value if needed
//             userID: 0, // If needed, set userID
//             companyID: 0, // If needed, set companyID
//             total: invoiceItems.reduce((total, item) => total + (item.unitPrice * item.quantity), 0), // Calculate the total
//             date: new Date().toISOString(), // Current date
//             clientId: clientId, // Ensure clientId is set
//             clientName: clientName,
//             mobileNumber: mobileNumber,
//             tax: tax,
//             discount: discount,
//             paidAmount: paidAmount,
//             advanceAmount: isAdvancePayment ? advanceAmount : 0,
//             remainingBalance: paidAmount + advanceAmount - invoiceItems.reduce((total, item) => total + (item.unitPrice * item.quantity), 0), // Calculate remaining balance
//             pendingStatus: "Pending", // Assuming the status is always "Pending" for new invoices
//             items: invoiceItems.map((item) => ({
//                 invoiceNumber: invoiceNumber,
//                 invoiceNumberId: 0, // Add logic if needed
//                 productName: item.productName,
//                 unitPrice: item.unitPrice,
//                 quantity: item.quantity,
//             })),
//         };

//         try {
//             const response = await axios.post("https://invoice.dockyardsoftware.com/api/Invoice", invoiceData);
//             console.log("Invoice submitted successfully", response.data);
//             alert("Invoice submitted successfully");
//         } catch (error) {
//             console.error("Error submitting invoice", error.response);
//             alert("Failed to submit invoice");
//         }

//         setLoading(false);
//     };

//     const fetchPendingInvoices = async () => {
//         setLoading(true);
//         try {
//             const response = await axios.get("https://invoice.dockyardsoftware.com/api/Invoice/PendingByCustomer", {
//                 params: { clientName, mobileNumber },
//             });

//             console.log("Fetched Data:", response.data);
//             const invoicesData = response.data?.$values || [];
//             setInvoices(invoicesData);
//             setError(null);
//         } catch (error) {
//             console.error("Error fetching invoices:", error.response);
//             setError(error.response?.data?.message || "Error fetching pending invoices");
//             setInvoices([]);
//         }
//         setLoading(false);
//     };

//     const fetchInvoiceItems = async (invoiceNumber) => {
//         try {
//             const response = await axios.get(`https://invoice.dockyardsoftware.com/api/Invoice/${invoiceNumber}`);
//             const items = response.data?.items?.$values || [];
//             console.log("Invoice Items Fetched:", items);
//             setInvoiceItems(items);
//         } catch (error) {
//             console.error("Error fetching invoice items:", error);
//         }
//     };

//     return (
//         <div className="flex flex-col items-center p-6">
//             <h2 className="text-2xl font-bold mb-4">Pending Invoices</h2>
//             <div className="mb-4 w-full max-w-md">
//                 <input
//                     type="text"
//                     placeholder="Client Name"
//                     value={clientName}
//                     onChange={(e) => setClientName(e.target.value)}
//                     className="border p-2 rounded w-full mb-2"
//                 />
//                 <input
//                     type="text"
//                     placeholder="Mobile Number"
//                     value={mobileNumber}
//                     onChange={(e) => setMobileNumber(e.target.value)}
//                     className="border p-2 rounded w-full mb-2"
//                 />
//                 <button
//                     onClick={fetchPendingInvoices}
//                     className="bg-blue-500 text-white p-2 rounded w-full"
//                 >
//                     {loading ? "Searching..." : "Search"}
//                 </button>
//             </div>
//             {error && <p className="text-red-500">{error}</p>}
//             <div className="overflow-x-auto w-full max-w-4xl">
//                 <table className="w-full text-sm text-left text-gray-500 border">
//                     <thead className="text-xs text-gray-700 uppercase bg-gray-200">
//                         <tr>
//                             <th className="px-4 py-3">Invoice Number</th>
//                             <th className="px-4 py-3">Base Invoice Number</th>
//                             <th className="px-4 py-3">Client Name</th>
//                             <th className="px-4 py-3">Total</th>
//                             <th className="px-4 py-3">Date</th>
//                             <th className="px-4 py-3">Paid</th>
//                             <th className="px-4 py-3">Advance</th>
//                             <th className="px-4 py-3">Remaining Balance</th>
//                             <th className="px-4 py-3">Pending</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {loading ? (
//                             <tr>
//                                 <td colSpan="9" className="text-center py-3 text-gray-500">
//                                     Loading invoices...
//                                 </td>
//                             </tr>
//                         ) : invoices.length > 0 ? (
//                             invoices.map((invoice) => (
//                                 <tr key={invoice.invoiceNumber} className="border">
//                                     <td className="px-4 py-2">{invoice.invoiceNumber}</td>
//                                     <td className="px-4 py-2">{invoice.baseInvoiceNumber}</td>
//                                     <td className="px-4 py-2">{invoice.clientName}</td>
//                                     <td className="px-4 py-2">{invoice.total}</td>
//                                     <td className="px-4 py-2">{invoice.date}</td>
//                                     <td className="px-4 py-2">{invoice.paidAmount}</td>
//                                     <td className="px-4 py-2">{invoice.advanceAmount}</td>
//                                     <td className="px-4 py-2">{invoice.remainingBalance}</td>
//                                     <td className="px-4 py-2">
//                                         {invoice.pendingStatus === "Pending" ? (
//                                             <a
//                                                 href="#"
//                                                 className="text-blue-500"
//                                                 onClick={() => fetchInvoiceItems(invoice.invoiceNumber)}
//                                             >
//                                                 Pending
//                                             </a>
//                                         ) : (
//                                             "Completed"
//                                         )}
//                                     </td>
//                                 </tr>
//                             ))
//                         ) : (
//                             <tr>
//                                 <td colSpan="9" className="text-center py-3 text-gray-500">
//                                     No invoices found
//                                 </td>
//                             </tr>
//                         )}
//                     </tbody>
//                 </table>
//             </div>

//          {/* Invoice Items table */}
// <div className="overflow-x-auto w-full max-w-4xl mt-6">
//     <h3 className="text-xl font-semibold mb-4">Invoice Items</h3>
//     <table className="w-full text-sm text-left text-gray-500 border">
//         <thead className="text-xs text-gray-700 uppercase bg-gray-200">
//             <tr>
//                 <th className="px-4 py-3">Product Name</th>
//                 <th className="px-4 py-3">Quantity</th>
//                 <th className="px-4 py-3">Unit Price</th>
//                 <th className="px-4 py-3">Amount</th>
//             </tr>
//         </thead>
//         <tbody>
//             {invoiceItems.length > 0 ? (
//                 // Display loaded invoice items
//                 invoiceItems.map((item, index) => (
//                     <tr key={index} className="border">
//                         <td className="px-4 py-2">{item.productName}</td>
//                         <td className="px-4 py-2">{item.quantity}</td>
//                         <td className="px-4 py-2">{item.unitPrice}</td>
//                         <td className="px-4 py-2">{item.unitPrice * item.quantity}</td>
//                     </tr>
//                 ))
//             ) : (
//                 // No items loaded, show an empty row with input fields for adding new items
//                 <tr className="border">
//                     <td className="px-4 py-2">
//                         <input
//                             type="text"
//                             value={invoiceItems.productName}
//                             onChange={(e) => setInvoiceItems({ ...invoiceItems, productName: e.target.value })}
//                             className="border p-2 rounded w-full"
//                             placeholder="Enter product name"
//                         />
//                     </td>
//                     <td className="px-4 py-2">
//                         <input
//                             type="number"
//                             value={invoiceItems.quantity}
//                             onChange={(e) => setInvoiceItems({ ...invoiceItems, quantity: e.target.value })}
//                             className="border p-2 rounded w-full"
//                             placeholder="Enter quantity"
//                         />
//                     </td>
//                     <td className="px-4 py-2">
//                         <input
//                             type="number"
//                             value={invoiceItems.unitPrice}
//                             onChange={(e) => setInvoiceItems({ ...invoiceItems, unitPrice: e.target.value })}
//                             className="border p-2 rounded w-full"
//                             placeholder="Enter unit price"
//                         />
//                     </td>
//                     <td className="px-4 py-2">
//                         {/* This shows the amount for the new entry */}
//                         {invoiceItems.quantity && invoiceItems.unitPrice
//                             ? invoiceItems.quantity * invoiceItems.unitPrice
//                             : 0}
//                     </td>
//                 </tr>
//             )}
//         </tbody>
//     </table>
//     {invoiceItems.length === 0 && (
//         <div className="flex justify-center mt-4">
//             <button
//                 onClick={() => {
//                     // Add the new item to the invoiceItems array
//                     setInvoiceItems([
//                         ...invoiceItems,
//                         {
//                             productName: invoiceItems.productName,
//                             quantity: invoiceItems.quantity,
//                             unitPrice: invoiceItems.unitPrice,
//                         },
//                     ]);
//                     // Reset fields after adding the item
//                     setInvoiceItems({ productName: "", quantity: "", unitPrice: "" });
//                 }}
//                 className="bg-blue-500 text-white px-4 py-2 rounded"
//             >
//                 Add Item
//             </button>
//         </div>
//     )}
// </div>

//             {/* Invoice Summary Section */}
//             <div className="w-full max-w-4xl mt-6 p-4 border rounded bg-gray-50">
            
//                 <div className="mb-4">
//                     <input
//                         type="checkbox"
//                         id="advancePayment"
//                         className="mr-2"
//                         checked={isAdvancePayment}
//                         onChange={(e) => setIsAdvancePayment(e.target.checked)}
//                     />
//                     <label htmlFor="advancePayment" className="text-gray-700">
//                         Is this an advance payment?
//                     </label>
//                 </div>

//                 {isAdvancePayment && (
//                     <div className="mt-4">
//                         <label className="block text-gray-700">Advance Payment Amount:</label>
//                         <input
//                             type="number"
//                             value={advanceAmount}
//                             onChange={(e) => setAdvanceAmount(e.target.value)}
//                             className="border p-2 rounded w-full"
//                             placeholder="Enter advance payment amount"
//                         />
//                     </div>
//                 )}

//                 <div className="grid grid-cols-2 gap-4 mt-4">
//                     <div>
//                         <label className="block text-gray-700">Tax (%)</label>
//                         <input
//                             type="number"
//                             value={tax}
//                             onChange={(e) => setTax(e.target.value)}
//                             className="border p-2 rounded w-full"
//                             placeholder="0"
//                         />
//                     </div>
//                     <div>
//                         <label className="block text-gray-700">Discount (%)</label>
//                         <input
//                             type="number"
//                             value={discount}
//                             onChange={(e) => setDiscount(e.target.value)}
//                             className="border p-2 rounded w-full"
//                             placeholder="0"
//                         />
//                     </div>
//                 </div>

//                 <div className="mt-4">
//                     <label className="block text-gray-700">Paid Amount:</label>
//                     <input
//                         type="number"
//                         value={paidAmount}
//                         onChange={(e) => setPaidAmount(e.target.value)}
//                         className="border p-2 rounded w-full"
//                         placeholder="0"
//                     />
//                 </div>

//                 <div className="flex justify-between items-center mt-6">
//                     <h3 className="text-lg font-bold">Total:</h3>
//                     <h3 className="text-lg font-bold text-gray-900">
//                         Rs. {invoiceItems.reduce((total, item) => total + (item.unitPrice * item.quantity), 0)}
//                     </h3>
//                 </div>

//                 <div className="mt-4 flex justify-center">
//                     <button
//                         onClick={handleSubmit}
//                         className="bg-blue-500 text-white px-4 py-2 rounded"
//                     >
//                         {loading ? "Submitting..." : "Submit Invoice"}
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// }



//reduce errro

import { useState, useEffect } from "react";
import axios from "axios";
import { useAuth, useInvoice } from '../AuthContext';

export default function PendingInvoices() {
      const { user } = useAuth();
      
    const [invoices, setInvoices] = useState([]);
    const [clientName, setClientName] = useState("");
    const [mobileNumber, setMobileNumber] = useState("");
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [invoiceItems, setInvoiceItems] = useState([]); // Ensure this is always an array
    const [isAdvancePayment, setIsAdvancePayment] = useState(false);
    const [tax, setTax] = useState(0);
    const [discount, setDiscount] = useState(0);
    const [paidAmount, setPaidAmount] = useState(0);
    const [advanceAmount, setAdvanceAmount] = useState(0);
    const [remainingBalance, setRemainingBalance] = useState(0);
    const [invoiceNumber, setInvoiceNumber] = useState("");
    const [baseInvoiceNumber, setBaseInvoiceNumber] = useState("");
    const [clientId, setClientId] = useState(0);

 

    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     setLoading(true);

    //     const invoiceNumber = `INV_${Date.now()}`;
       

    //     // Ensure invoiceItems is always an array
    //     if (!Array.isArray(invoiceItems)) {
    //         setInvoiceItems([]);
    //     }

    //     const invoiceData = {
    //         invoiceNumber: invoiceNumber, 
    //         baseInvoiceNumber: baseInvoiceNumber, 
    //         baseInvoiceNumberId: 0, 
    //         userID: user.userID,
    //         companyID: user.companyID,
    //         total: invoiceItems.reduce((total, item) => total + (item.unitPrice * item.quantity), 0), 
    //         date: new Date().toISOString(), 
    //         clientId: clientId, 
    //         clientName: clientName,
    //         mobileNumber: mobileNumber,
    //         tax: tax,
    //         discount: discount,
    //         paidAmount: paidAmount,
    //         advanceAmount: isAdvancePayment ? advanceAmount : 0,
    //         remainingBalance: paidAmount + advanceAmount - invoiceItems.reduce((total, item) => total + (item.unitPrice * item.quantity), 0), 
    //         pendingStatus: "Pending", 
    //         items: invoiceItems.map((item) => ({
    //             invoiceNumber: invoiceNumber,
    //             invoiceNumberId: 0, 
    //             productName: item.productName,
    //             unitPrice: item.unitPrice,
    //             quantity: item.quantity,
    //         })),
    //     };

    //     try {
    //         const response = await axios.post("https://invoice.dockyardsoftware.com/api/Invoice", invoiceData);
    //         console.log("Invoice submitted successfully", response.data);
    //         alert("Invoice submitted successfully");
    //     } catch (error) {
    //         console.error("Error submitting invoice", error.response);
    //         alert("Failed to submit invoice");
    //     }

    //     setLoading(false);
    // };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
    
        let finalInvoiceNumber = invoiceNumber;
        let finalBaseInvoiceNumber = baseInvoiceNumber;
        let finalBaseInvoiceNumberId = 0; // Default value
        let finalAdvanceAmount = isAdvancePayment ? advanceAmount : 0; // Default advance amount
    
        // Check if there's an existing unsettled invoice (with remaining balance)
        const existingInvoice = invoices.find(inv => inv.invoiceNumber === invoiceNumber && inv.remainingBalance > 0);
    
        if (existingInvoice) {
            // Use the existing invoice details if there's an unsettled payment
            finalInvoiceNumber = existingInvoice.invoiceNumber;
            finalBaseInvoiceNumber = existingInvoice.baseInvoiceNumber;
            finalBaseInvoiceNumberId = existingInvoice.baseInvoiceNumberId;
            finalAdvanceAmount = existingInvoice.advanceAmount; // Maintain the advance amount
        } else if (!invoiceNumber) {
            // Generate a new invoice number only if it's a truly new invoice (no invoice number exists)
            finalInvoiceNumber = `INV_${Date.now()}`;
        }
    
        // Calculate total and remaining balance
        const totalAmount = invoiceItems.reduce((total, item) => total + (item.unitPrice * item.quantity), 0);
        const newRemainingBalance = totalAmount - (paidAmount + finalAdvanceAmount); // Use carried advance amount
    
        // Ensure we are not generating a new invoice for an unsettled payment
        if (existingInvoice) {
            console.log("Unsettled invoice found. Reusing the existing invoice details:", existingInvoice);
        } else {
            console.log("No unsettled invoice found. Creating a new invoice:", finalInvoiceNumber);
        }
    
        const invoiceData = {
            invoiceNumber: finalInvoiceNumber,
            baseInvoiceNumber: finalBaseInvoiceNumber,
            baseInvoiceNumberId: finalBaseInvoiceNumberId,
            userID: user.userID,
            companyID: user.companyID,
            total: totalAmount,
            date: new Date().toISOString(),
            clientId: clientId,
            clientName: clientName,
            mobileNumber: mobileNumber,
            tax: tax,
            discount: discount,
            paidAmount: paidAmount,
            advanceAmount: finalAdvanceAmount, // Ensure advance is maintained
            remainingBalance: newRemainingBalance,
            pendingStatus: newRemainingBalance > 0 ? "Pending" : "Completed",
            items: invoiceItems.map((item) => ({
                invoiceNumber: finalInvoiceNumber,
                invoiceNumberId: 0,
                productName: item.productName,
                unitPrice: item.unitPrice,
                quantity: item.quantity,
            })),
        };
    
        console.log("Sending Invoice Data:", invoiceData); // Log data before sending
    
        try {
            const response = await axios.post("https://invoice.dockyardsoftware.com/api/Invoice", invoiceData);
            console.log("Invoice submitted successfully", response.data);
            alert("Invoice submitted successfully");
        } catch (error) {
            console.error("Error submitting invoice", error.response);
            alert("Failed to submit invoice");
        }
    
        setLoading(false);
    };
    
    const fetchPendingInvoices = async () => {
        setLoading(true);
        try {
            const response = await axios.get("https://invoice.dockyardsoftware.com/api/Invoice/PendingByCustomer", {
                params: { clientName, mobileNumber },
            });

            console.log("Fetched Data:", response.data);
            const invoicesData = response.data?.$values || [];
            setInvoices(invoicesData);
            setError(null);
        } catch (error) {
            console.error("Error fetching invoices:", error.response);
            setError(error.response?.data?.message || "Error fetching pending invoices");
            setInvoices([]);
        }
        setLoading(false);
    };

    // const fetchInvoiceItems = async (invoiceNumber) => {
    //     try {
    //         const response = await axios.get(`https://invoice.dockyardsoftware.com/api/Invoice/${invoiceNumber}`);
    //         const items = response.data?.items?.$values || [];
    //         console.log("Invoice Items Fetched:", items);
    //         setInvoiceItems(items);
    //     } catch (error) {
    //         console.error("Error fetching invoice items:", error);
    //     }
    // };

    const fetchInvoiceItems = async (invoiceNumber) => {
        try {
            const response = await axios.get(`https://invoice.dockyardsoftware.com/api/Invoice/${invoiceNumber}`);
            const invoiceData = response.data; // Ensure response.data is being accessed correctly
            console.log("API Response Data:", response.data);  // Corrected logging
    
          
            if (invoiceData) {
                const totalAmount = invoiceData.items?.$values?.reduce(
                    (total, item) => total + item.unitPrice * item.quantity,
                    0
                ) || 0;
    
                const remainingBalance = Math.max(
                    totalAmount - (invoiceData.paidAmount + (invoiceData.advanceAmount || 0)),
                    0
                );
    
                setInvoiceNumber(invoiceData.invoiceNumber);
                setBaseInvoiceNumber(invoiceData.baseInvoiceNumber);
                setClientId(invoiceData.clientId);
                setClientName(invoiceData.clientName);
                setMobileNumber(invoiceData.mobileNumber);
                setTax(invoiceData.tax);
                setDiscount(invoiceData.discount);
                setPaidAmount(invoiceData.paidAmount);
                setAdvanceAmount(invoiceData.advanceAmount);
                setInvoiceItems(invoiceData.items?.$values || []);
                setRemainingBalance(invoiceData.remainingBalance);  // <-- Added this
            }
        } catch (error) {
            console.error("Error fetching invoice details:", error);
        }
    };
    
    const handleItemChange = (index, field, value) => {
        const updatedItems = [...invoiceItems];
        updatedItems[index] = {
            ...updatedItems[index],
            [field]: value,
        };
        setInvoiceItems(updatedItems);
    };

    const handleAddItem = () => {
        setInvoiceItems([
            ...invoiceItems,
            { productName: "", quantity: "", unitPrice: "" },
        ]);
    };

    return (
        <div className="flex flex-col items-center p-6">
            <h2 className="text-2xl font-bold mb-4">Pending Invoices</h2>
            <div className="mb-4 w-full max-w-md">
                <input
                    type="text"
                    placeholder="Client Name"
                    value={clientName}
                    onChange={(e) => setClientName(e.target.value)}
                    className="border p-2 rounded w-full mb-2"
                />
                <input
                    type="text"
                    placeholder="Mobile Number"
                    value={mobileNumber}
                    onChange={(e) => setMobileNumber(e.target.value)}
                    className="border p-2 rounded w-full mb-2"
                />
                <button
                    onClick={fetchPendingInvoices}
                    className="bg-blue-500 text-white p-2 rounded w-full"
                >
                    {loading ? "Searching..." : "Search"}
                </button>
            </div>
            {error && <p className="text-red-500">{error}</p>}
            <div className="overflow-x-auto w-full max-w-4xl">
                <table className="w-full text-sm text-left text-gray-500 border">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-200">
                        <tr>
                            <th className="px-4 py-3">Invoice Number</th>
                            <th className="px-4 py-3">Base Invoice Number</th>
                            <th className="px-4 py-3">Client Name</th>
                            <th className="px-4 py-3">Total</th>
                            <th className="px-4 py-3">Date</th>
                            <th className="px-4 py-3">Paid</th>
                            <th className="px-4 py-3">Advance</th>
                            <th className="px-4 py-3">Remaining Balance</th>
                            <th className="px-4 py-3">Pending</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="9" className="text-center py-3 text-gray-500">
                                    Loading invoices...
                                </td>
                            </tr>
                        ) : invoices.length > 0 ? (
                            invoices.map((invoice) => (
                                <tr key={invoice.invoiceNumber} className="border">
                                    <td className="px-4 py-2">{invoice.invoiceNumber}</td>
                                    <td className="px-4 py-2">{invoice.baseInvoiceNumber}</td>
                                    <td className="px-4 py-2">{invoice.clientName}</td>
                                    <td className="px-4 py-2">{invoice.total}</td>
                                    <td className="px-4 py-2">{invoice.date}</td>
                                    <td className="px-4 py-2">{invoice.paidAmount}</td>
                                    <td className="px-4 py-2">{invoice.advanceAmount}</td>
                                    <td className="px-4 py-2">{invoice.remainingBalance}</td>
                                    <td className="px-4 py-2">
                                        {invoice.pendingStatus === "Pending" ? (
                                         <a
                                         href="#"
                                         className="text-blue-500"
                                         onClick={() => {
                                             console.log("Clicked Invoice Number:", invoice.invoiceNumber);
                                             fetchInvoiceItems(invoice.invoiceNumber);
                                             console.log("Fetching data for invoice:", invoiceNumber);
                                         }}
                                      >
                                         Pending
                                      </a>
                                      
                                        ) : (
                                            "Completed"
                                        )}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="9" className="text-center py-3 text-gray-500">
                                    No invoices found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Invoice Items table */}
            <div className="overflow-x-auto w-full max-w-4xl mt-6">
                <h3 className="text-xl font-semibold mb-4">Invoice Items</h3>
                <table className="w-full text-sm text-left text-gray-500 border">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-200">
                        <tr>
                     
                            <th className="px-4 py-3">Product Name</th>
                            <th className="px-4 py-3">Quantity</th>
                            <th className="px-4 py-3">Unit Price</th>
                            <th className="px-4 py-3">Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {invoiceItems.length > 0 ? (
                            invoiceItems.map((item, index) => (
                                <tr key={index} className="border">


                                    <td className="px-4 py-2">
                                        <input
                                            type="text"
                                            value={item.productName}
                                            onChange={(e) => handleItemChange(index, 'productName', e.target.value)}
                                            className="border p-2 rounded w-full"
                                            placeholder="Enter product name"
                                        />
                                    </td>
                                    <td className="px-4 py-2">
                                        <input
                                            type="number"
                                            value={item.quantity}
                                            onChange={(e) => handleItemChange(index, 'quantity', e.target.value)}
                                            className="border p-2 rounded w-full"
                                            placeholder="Enter quantity"
                                        />
                                    </td>
                                    <td className="px-4 py-2">
                                        <input
                                            type="number"
                                            value={item.unitPrice}
                                            onChange={(e) => handleItemChange(index, 'unitPrice', e.target.value)}
                                            className="border p-2 rounded w-full"
                                            placeholder="Enter unit price"
                                        />
                                    </td>
                                    <td className="px-4 py-2">
                                        {item.quantity && item.unitPrice ? item.quantity * item.unitPrice : 0}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="4" className="text-center py-3 text-gray-500">
                                    No items added yet.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <div className="flex justify-center mt-4">
                    <button
                        onClick={handleAddItem}
                        className="bg-blue-500 text-white px-4 py-2 rounded"
                    >
                        Add Item
                    </button>
                </div>
            </div>

            {/* Invoice Summary Section */}
            <div className="w-full max-w-4xl mt-6 p-4 border rounded bg-gray-50">
                <div className="mb-4">
                    <input
                        type="checkbox"
                        id="advancePayment"
                        className="mr-2"
                        checked={isAdvancePayment}
                        onChange={(e) => setIsAdvancePayment(e.target.checked)}
                    />
                    <label htmlFor="advancePayment" className="text-gray-700">
                        Is this an advance payment?
                    </label>
                </div>

                {isAdvancePayment && (
                    <div className="mt-4">
                        <label className="block text-gray-700">Advance Payment Amount:</label>
                        <input
                            type="number"
                            value={advanceAmount}
                            onChange={(e) => setAdvanceAmount(e.target.value)}
                            className="border p-2 rounded w-full"
                            placeholder="Enter advance payment amount"
                        />
                    </div>
                )}

                <div className="grid grid-cols-2 gap-4 mt-4">
                    <div>
                        <label className="block text-gray-700">Tax (%)</label>
                        <input
                            type="number"
                            value={tax}
                            onChange={(e) => setTax(e.target.value)}
                            className="border p-2 rounded w-full"
                            placeholder="0"
                        />
                    </div>
                    <div>
                        <label className="block text-gray-700">Discount (%)</label>
                        <input
                            type="number"
                            value={discount}
                            onChange={(e) => setDiscount(e.target.value)}
                            className="border p-2 rounded w-full"
                            placeholder="0"
                        />
                    </div>
                </div>

                <div className="mt-4">
                    <label className="block text-gray-700">Paid Amount:</label>
                    <input
                        type="number"
                        value={paidAmount}
                        onChange={(e) => setPaidAmount(e.target.value)}
                        className="border p-2 rounded w-full"
                        placeholder="0"
                    />
                </div>

                <div className="flex justify-between items-center mt-6">
                    <h3 className="text-lg font-bold">Total:</h3>
                    <h3 className="text-lg font-bold text-gray-900">
                        Rs. {invoiceItems.reduce((total, item) => total + (item.unitPrice * item.quantity), 0)}
                    </h3>
                </div>

                <div className="mt-4 flex justify-center">
                    <button
                        onClick={handleSubmit}
                        className="bg-blue-500 text-white px-4 py-2 rounded"
                    >
                        {loading ? "Submitting..." : "Submit Invoice"}
                    </button>
                </div>
            </div>
        </div>
    );
}
 